import { Box, Button, Container, Menu, MenuItem, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchTeacherProfile } from "../../redux/Actions/teacherProfileActions";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { 
    AdminPanelSettings as AdminIcon, 
    School as StudentIcon, 
    MenuBook as TeacherIcon,
    Psychology as ConsultantIcon,
    WorkOutline as AusbildungIcon
} from '@mui/icons-material';

const ctaButtonSx = {
  fontWeight: "bold",
  borderRadius: 24,
  px: 2,
  py: 0.5,
  fontSize: "0.95rem",
  mb: 0,
  minWidth: 120,
};

const AccessDashboardButton = () => {
  const { t } = useTranslation();
  const isLoggedIn = useSelector((state) => state.auth.isAuthenticated);
  const roleName = useSelector((state) => state.auth.user.roleName);
  const roleNames = useSelector((state) => state.auth.user.roleNames); // ✅

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (roleName === "Teacher") {
      dispatch(fetchTeacherProfile());
    }
  }, [roleName, dispatch]);

  const [anchorEl, setAnchorEl] = useState(null); // ✅ For dropdown

  const handleDropdownClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDropdownClose = () => {
    setAnchorEl(null);
  };

  const navigateToDashboard = (path) => {
    navigate(path);
    handleDropdownClose();
  };

  // useEffect(() => {
  //   dispatch(fetchCourseCatalog());
  // }, [dispatch]);

  return (
    <Box sx={{ textAlign: "center" }}>
      <Container className="content-container">
        <Box>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {isLoggedIn && (() => {
              const dashboards = [];
              if (roleNames?.some(r => r.toUpperCase() === "ADMIN" || r.toUpperCase() === "ADMIN_DEVELOPER")) {
                dashboards.push({ label: "Admin Dashboard", path: "/dashboard?view=admin", icon: <AdminIcon sx={{ fontSize: 20 }} /> });
              }
              if (roleNames?.some(r => r.toUpperCase() === "TEACHER" || r.toUpperCase() === "TEACHER_MANAGER")) {
                dashboards.push({ label: "Teacher Dashboard", path: "/dashboard?view=teacher", icon: <TeacherIcon sx={{ fontSize: 20 }} /> });
              }
              if (roleNames?.some(r => r.toUpperCase() === "CONSULTANT")) {
                dashboards.push({ label: "Consultant Dashboard", path: "/dashboard?view=consultant", icon: <ConsultantIcon sx={{ fontSize: 20 }} /> });
              }
              if (roleNames?.some(r => r.toUpperCase() === "AUSBILDUNG_MANAGER")) {
                dashboards.push({ label: "Ausbildung Dashboard", path: "/dashboard?view=ausbildung_manager", icon: <AusbildungIcon sx={{ fontSize: 20 }} /> });
              }
              if (roleNames?.some(r => r.toUpperCase() === "STUDENT")) {
                dashboards.push({ label: "Student Dashboard", path: "/dashboard?view=student", icon: <StudentIcon sx={{ fontSize: 20 }} /> });
              }

              if (dashboards.length === 0) {
                dashboards.push({ label: "Student Dashboard", path: "/dashboard", icon: <StudentIcon sx={{ fontSize: 20 }} /> });
              }

              if (dashboards.length > 1) {
                return (
                  <>
                    <Button
                      variant="contained"
                      sx={ctaButtonSx}
                      onClick={handleDropdownClick}
                      endIcon={<KeyboardArrowDownIcon />}
                    >
                      {t("homeBanner.accessDashboard")}
                    </Button>
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleDropdownClose}
                      PaperProps={{
                        sx: {
                          mt: 1,
                          borderRadius: 2,
                          minWidth: 200,
                          boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
                        }
                      }}
                    >
                      {dashboards.map((db, idx) => (
                        <MenuItem 
                          key={idx} 
                          onClick={() => navigateToDashboard(db.path)}
                          sx={{ py: 1.2, px: 2, gap: 1.5 }}
                        >
                          {db.icon}
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {db.label}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Menu>
                  </>
                );
              } else {
                return (
                  <Button
                    variant="contained"
                    sx={ctaButtonSx}
                    onClick={() => navigate(dashboards[0]?.path || "/dashboard")}
                  >
                    {t("homeBanner.accessDashboard")}
                  </Button>
                );
              }
            })()}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default AccessDashboardButton;
